module.exports = __webpack_public_path__ + "static/img/45.d755805f.png";